<template>
    <div class="avatar">
        <slot name="tooltip-content"></slot>
        <div class="flex-content text-center">
            <div class="avatar-inner">
                <div class="avatar-inner">
                    {{short}}
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        name: 'Avatar',
        components: {},
        props: {
            name: {
                type: String
            },
        },
        data () {
            return {

            }
        },
        computed: {
            short(){
                if(this.name) {
                    let names = this.name.split(" ");
                    let short = names[0].substring(0, 1) + names[names.length - 1].substring(0, 1);
                    short = short.toUpperCase();
                    return short;
                }
                else{
                    return '';
                }
            }
        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Avatar.scss" scoped lang="scss"></style>

